import { useNavigate, useOutletContext } from 'react-router-dom';
import { SignupFlowStart } from '../../components/signup';
import { SignupOutletContext } from '../../components/signup/types';
import { useFeatureFlags } from '../../hooks/useFeatureFlags';
import { useFlowType } from '../../hooks/useFlowType';
import { LoadingSpinner } from 'design-system/src/components/LoadingSpinner/LoadingSpinner';

const SignupStartPage = () => {
  const navigate = useNavigate();
  const { formState, updateFormState } = useOutletContext<SignupOutletContext>();
  const { data: featureFlags, isLoading: isLoadingFeatureFlags } = useFeatureFlags();
  const flowType = useFlowType();

  const isDemoFlow = flowType === 'demo';
  const utmParams = {
    utm_source: formState.utm_source,
    utm_medium: formState.utm_medium,
    utm_campaign: formState.utm_campaign,
    utm_term: formState.utm_term,
    utm_content: formState.utm_content,
  };

  const googleAdClickId = formState.google_ad_click_id;

  const handleNavigateFromSignupFlowStart = (skipToVerificationEmail?: boolean) => {
    const basePath = `/${flowType}`;

    if (skipToVerificationEmail && (featureFlags?.providerSignupFlow || featureFlags?.providerSplitSignup)) {
      navigate('/signup/verification-email', { replace: true });
    } else {
      navigate(`${basePath}/profile-info`);
    }
  };

  const setSignupId = (signupId: string) => {
    localStorage.setItem('signupId', signupId);
    updateFormState({ source: `${flowType}_flow` });
  };

  const setEmail = (email: string) => {
    localStorage.setItem('email', email);
    updateFormState({ email });
  };

  if (isLoadingFeatureFlags) {
    return <LoadingSpinner />;
  }

  return (
    <SignupFlowStart
      onNext={handleNavigateFromSignupFlowStart}
      setSignupId={setSignupId}
      setEmail={setEmail}
      defaultEmail={formState.email}
      isDemoFlow={isDemoFlow}
      utmParams={utmParams}
      googleAdClickId={googleAdClickId}
    />
  );
};

export default SignupStartPage;
